/// <amd-module name="TFS/Admin/Groups/Dialogs/GroupAddPanel/TeamsPermissionsPickerProvider" />
import * as React from "react";
import { IdentityPicker, IIdentity, IPeoplePickerProvider, IPersonaConnections } from "VSSUI/IdentityPicker";

export class TeamsPermissionsPickerProvider implements IPeoplePickerProvider {
    private currentPersonas: IIdentity[] = [];
    private personas: IIdentity[];

    constructor(groups: IIdentity[]) {
        this.personas = groups;
        this.allPersonas = groups;
    }

    private allPersonas: IIdentity[];

    public onFilterIdentities(filter: string, selectedItems?: IIdentity[]) {
        return this.getPersonaList(filter, selectedItems);
    }

    public getEntityFromUniqueAttribute = (entityId: string): IIdentity => {
        return this.allPersonas.filter(x => x.entityId === entityId)[0];
    };

    public onRequestConnectionInformation = (entity: IIdentity, getDirectReports?: boolean): IPersonaConnections => {
        return {
            directReports: getDirectReports ? [] : undefined,
            managers: []
        };
    };

    public onEmptyInputFocus(): IIdentity[] {
        return this.personas;
    }

    // Simulate initial request delay when the user first tries to grab a list
    private getPersonaList(filter: string, selectedItems?: IIdentity[]): Promise<IIdentity[]> | IIdentity[] {
        if (this.currentPersonas.length > 0) {
            return this.filterList(filter, selectedItems);
        } else {
            return new Promise<IIdentity[]>((resolve, reject) =>
                setTimeout(() => {
                    this.currentPersonas = this.personas;
                    resolve(this.filterList(filter, selectedItems));
                }, 500)
            );
        }
    }

    private filterList(filter: string, selectedItems?: IIdentity[]) {
        if (filter === "") {
            return this.onEmptyInputFocus();
        }
        return this.currentPersonas.filter(
            x =>
                (selectedItems === undefined || selectedItems.indexOf(x) === -1) &&
                ((x.displayName && x.displayName.toLowerCase().indexOf(filter.toLowerCase()) !== -1) ||
                    (x.mail && x.mail.toLowerCase().indexOf(filter.toLowerCase()) !== -1))
        );
    }
}
